import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import {
  transactionCreated,
  transactionCreating,
  transactionCreatingError,
  transactionDuplicate,
} from "./transactionStateActions";

interface TransactionState {
  creating: boolean;
  created: boolean;
  error: string | null;
  duplicateId?: number;
}

const initialState: TransactionState = {
  creating: false,
  created: false,
  error: null,
};

const transactionSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
    builder
      .addCase(transactionCreating, (state) => {
        state.creating = true;
        state.created = false;
        state.error = null;
        state.duplicateId = undefined;
      })
      .addCase(transactionCreated, (state) => {
        state.creating = false;
        state.created = true;
        state.duplicateId = undefined;
      })
      .addCase(transactionDuplicate, (state, action) => {
        state.creating = false;
        state.created = false;
        state.error = null;
        state.duplicateId = action.payload;
      })
      .addCase(transactionCreatingError, (state, action) => {
        state.creating = false;
        state.created = false;
        state.error = action.payload;
        state.duplicateId = undefined;
      });
  },
});

export default transactionSlice.reducer;
